export default __webpack_public_path__ + "static/media/Featured Books.114d2e2d.svg";